/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class CometRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model(params) {
    return this.store.findRecord('goals/goal', params.goal_id).then((goal) => {
      return hash({
        goal,
        category: this.store.findRecord(
          'goals/category',
          goal.get('category_id'),
        ),
        subject: this.store.findRecord('goals/subject', goal.get('subject_id')),
      }).then((results) => {
        return this.store
          .query('coach/goal-plan', {
            jurisdiction: this.session.get('school.jurisdiction'),
            academicLevel: results.category.get('label'),
            subject: results.subject.get('label'),
            goal: results.goal.get('educatorDescription'),
          })
          .then((goalPlan) => {
            return hash({
              goal: results.goal,
              goalPlan,
            });
          });
      });
    });
  }
}
